/*
 * @Author: 土田共破折点撇横钩竖横竖横横
 * @Date: 2023-05-17 11:44:00
 * @LastEditTime: 2024-03-05 13:17:23
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\cost-control\cost-settle-accounts\modules\bussinessTypeRouter.js
 * 流向结算
 */
const bussinessTypeRouter = [
  // 费控系统 费用结算管理 商务模式 费用计提预算表
  {
    path: '/costControlSystem/bussiness-type/provision-budget-cost/page',
    name: 'costControlSystemProvisionBudgetCostPage',
    component: () =>
      import(
        /*webpackChunkName:"costControlSystemProvisionBudgetCostPage" */
        '@/views/costControlSystem/deliverySettlement/bussinessType/provisionBudgetCost/Page.vue'
        ),
    meta: {
      SecondaryMenu: '商务模式', //二级菜单
      title: '费用计提预算表',
      breadcrumb: [
        {
          title: '商务模式',
          name: '',
        },
      ],
    },
  },

  // 费控系统 费用结算管理 商务模式 商业返利
  {
    path: '/costControlSystem/bussiness-type/commercial-rebates/page',
    name: 'costControlSystemCommercialRebatesPage',
    component: () =>
      import(
        /*webpackChunkName:"costControlSystemProvisionBudgetCostPage" */
        '@/views/costControlSystem/deliverySettlement/bussinessType/commercialRebates/Page.vue'
        ),
    meta: {
      SecondaryMenu: '商务模式', //二级菜单
      title: '商业返利',
    },
  },

  // 费控系统 费用结算管理 商务模式 发起商业返利申请
  {
    path: '/costControlSystem/bussiness-type/commercial-rebates/edit/:id',
    name: 'costControlSystemProvisionBudgetCostEdit',
    component: () =>
      import(
        /*webpackChunkName:"costControlSystemProvisionBudgetCostAdd" */
        '@/views/costControlSystem/deliverySettlement/bussinessType/commercialRebates/Edit.vue'
        ),
    meta: {
      SecondaryMenu: '商务模式', //二级菜单
      title: '发起返利申请',
      breadcrumb: [
        {
          title: '商务模式',
          name: '',
        },
        {
          title: '商业返利',
          name: 'costControlSystemCommercialRebatesPage',
        },
      ],
    },
  },

  // 费控系统 费用结算管理 商务模式 商业返利详情
  {
    path: '/costControlSystem/bussiness-type/commercial-rebates/detail/:id',
    name: 'costControlSystemProvisionBudgetCostDetail',
    component: () =>
      import(
        /*webpackChunkName:"costControlSystemProvisionBudgetCostAdd" */
        '@/views/costControlSystem/deliverySettlement/bussinessType/commercialRebates/Detail.vue'
        ),
    meta: {
      SecondaryMenu: '商务模式', //二级菜单
      title: '商业返利明细',
      breadcrumb: [
        {
          title: '商务返利',
          name: 'costControlSystemCommercialRebatesPage',
        },
      ],
    },
  },



  // 费控系统 费用结算管理 商务模式 纯销结算单
  {
    path: '/costControlSystem/bussiness-type/pure-pin-statement/page',
    name: 'costControlSystemPurePinStatementPage',
    component: () =>
      import(
        /*webpackChunkName:"costControlSystemPurePinStatementPage" */
        '@/views/costControlSystem/deliverySettlement/bussinessType/purePinStatement/Page.vue'
        ),
    meta: {
      SecondaryMenu: '商务模式', //二级菜单
      title: '纯销结算单',
      breadcrumb: [
        {
          title: '商务模式',
          name: '',
        },
      ],
    },
  },

  // 费控系统 费用结算管理 商务模式 纯销结算单明细
  {
    path: '/costControlSystem/bussiness-type/pure-pin-statement/detail/:id',
    name: 'costControlSystemPurePinStatementDetail',
    component: () =>
      import(
        /*webpackChunkName:"costControlSystemPurePinStatementDetail" */
        '@/views/costControlSystem/deliverySettlement/bussinessType/purePinStatement/Detail.vue'
        ),
    meta: {
      SecondaryMenu: '商务模式', //二级菜单
      title: '纯销结算单明细',
      breadcrumb: [
        {
          title: '商务模式',
          name: '',
        },
        {
          title: '纯销结算单',
          name: 'costControlSystemPurePinStatementPage',
        },
      ],
    },
  },

  // 费控系统 费用结算管理 商务模式 纯销结算单导入
  {
    path: '/costControlSystem/bussiness-type/pure-pin-statement/upload',
    name: 'costControlSystemPurePinStatementUpload',
    component: () =>
      import(
        /*webpackChunkName:"costControlSystemPurePinStatementDetail" */
        '@/views/costControlSystem/deliverySettlement/bussinessType/purePinStatement/Upload.vue'
        ),
    meta: {
      SecondaryMenu: '商务模式', //二级菜单
      title: '纯销单导入',
      breadcrumb: [
        {
          title: '商务模式',
          name: '',
        },
        {
          title: '纯销结算单',
          name: 'costControlSystemPurePinStatementPage',
        },
      ],
    },
  },

  // 费控系统 费用结算管理 商务模式 费用拨付表
  {
    path: '/costControlSystem/bussiness-type/payment-list/page',
    name: 'costControlSystemPaymentListPage',
    component: () =>
      import(
        /*webpackChunkName:"costControlSystemPaymentListPage" */
        '@/views/costControlSystem/deliverySettlement/bussinessType/paymentList/Page'
        ),
    meta: {
      SecondaryMenu: '商务模式', //二级菜单
      title: '费用拨付表',
      breadcrumb: [
        {
          title: '商务模式',
          name: '',
        },
      ],
    },
  },

  // 费控系统 费用结算管理 商务模式 费用拨付表 导入
  {
    path: '/costControlSystem/bussiness-type/payment-list/upload',
    name: 'costControlSystemPaymentListUpload',
    component: () =>
      import(
        /*webpackChunkName:"costControlSystemPaymentListPage" */
        '@/views/costControlSystem/deliverySettlement/bussinessType/paymentList/Upload'
        ),
    meta: {
      SecondaryMenu: '商务模式', //二级菜单
      title: '导入已拨付数据',
      breadcrumb: [
        {
          title: '商务模式',
          name: '',
        },
        {
          title: '费用拨付表',
          name: 'costControlSystemPaymentListPage',
        },
      ],
    },
  },



  

  // 费控系统 费用结算管理 商务模式 商业返利汇总表
  {
    path: '/costControlSystem/bussiness-type/commercial-rebates/summary/page',
    name: 'costControlSystemCommercialSummaryPage',
    component: () =>
      import(
        /*webpackChunkName:"costControlSystemCommercialSummaryPage" */
        '@/views/costControlSystem/deliverySettlement/bussinessType/commercialRebatesSummary/Page.vue'
        ),
    meta: {
      SecondaryMenu: '商务模式', //二级菜单
      title: '商业返利汇总表',
      breadcrumb: [
        {
          title: '商务模式',
          name: '',
        },
      ],
    },
  },

  // 费控系统 费用结算管理 商务模式 商业返利汇总表
  {
    path: '/costControlSystem/bussiness-type/commercial-rebates/summary/detail/:id/:filterJson',
    name: 'costControlSystemCommercialSummaryDetail',
    component: () =>
      import(
        /*webpackChunkName:"costControlSystemCommercialSummaryDetail" */
        '@/views/costControlSystem/deliverySettlement/bussinessType/commercialRebatesSummary/Detail.vue'
        ),
    meta: {
      SecondaryMenu: '商务模式', //二级菜单
      title: '商业返利汇总详情',
      breadcrumb: [
        {
          title: '商业返利汇总表',
          name: 'costControlSystemCommercialSummaryPage',
        },
      ],
    },
  },

  

]
export default bussinessTypeRouter